import React from 'react';

// Importaciones de todas las imágenes
import imgAnilloBodasPrev from '../assets/anillo-de-bodas-preview.webp';

// SL1
import imgSl1BrillanteBlanco from '../assets/SL1_Optimizadas/TressorAnillosSL1BrillanteOroBlanco.webp';
import imgSl1BrillanteAmarillo from '../assets/SL1_Optimizadas/TressorAnillosSL1BrillanteOroAmarillo.webp';
import imgSl1CushionBlanco from '../assets/SL1_Optimizadas/TressorAnillosSL1CrushionOroBlanco.webp';
import imgSl1CushionAmarillo from '../assets/SL1_Optimizadas/TressorAnillosSL1CrushionOroAmarillo.webp';
import imgSl1OvaladoBlanco from '../assets/SL1_Optimizadas/TressorAnillosSL1OvalOroBlanco.webp';
import imgSl1OvaladoAmarillo from '../assets/SL1_Optimizadas/TressorAnillosSL1OvalOroAmarillo.webp';
import imgSl1PrincesaBlanco from '../assets/SL1_Optimizadas/TressorAnillosSL1PrincesaOroBlanco.webp';
import imgSl1PrincesaAmarillo from '../assets/SL1_Optimizadas/TressorAnillosSL1PrincesaOroAmarillo.webp';

// SL2
import imgSl2BrillanteBlanco from '../assets/SL2_Optimizadas/TressorAnillosSL2BrillanteOroBlanco.webp';
import imgSl2BrillanteAmarillo from '../assets/SL2_Optimizadas/TressorAnillosSL2BrillanteOroAmarillo.webp';
import imgSl2CushionBlanco from '../assets/SL2_Optimizadas/TressorAnillosSL2CrushionOroBlanco.webp';
import imgSl2CushionAmarillo from '../assets/SL2_Optimizadas/TressorAnillosSL2CrushionOroAmarillo.webp';
import imgSl2OvaladoBlanco from '../assets/SL2_Optimizadas/TressorAnillosSL2OvalOroBlanco.webp';
import imgSl2OvaladoAmarillo from '../assets/SL2_Optimizadas/TressorAnillosSL2OvalOroAmarillo.webp';
import imgSl2PrincesaBlanco from '../assets/SL2_Optimizadas/TressorAnillosSL2PrincesaOroBlanco.webp';
import imgSl2PrincesaAmarillo from '../assets/SL2_Optimizadas/TressorAnillosSL2PrincesaOroAmarillo.webp';

// SL3
import imgSl3BrillanteBlanco from '../assets/SL3_Optimizadas/TressorAnillosSL3BrillanteOroBlanco.webp';
import imgSl3BrillanteAmarillo from '../assets/SL3_Optimizadas/TressorAnillosSL3BrillanteOroAmarillo.webp';
import imgSl3CushionBlanco from '../assets/SL3_Optimizadas/TressorAnillosSL3CrushionOroBlanco.webp';
import imgSl3CushionAmarillo from '../assets/SL3_Optimizadas/TressorAnillosSL3CrushionOroAmarillo.webp';
import imgSl3OvaladoBlanco from '../assets/SL3_Optimizadas/TressorAnillosSL3OvalOroBlanco.webp';
import imgSl3OvaladoAmarillo from '../assets/SL3_Optimizadas/TressorAnillosSL3OvalOroAmarillo.webp';
import imgSl3PrincesaBlanco from '../assets/SL3_Optimizadas/TressorAnillosSL3PrincesaOroBlanco.webp';
import imgSl3PrincesaAmarillo from '../assets/SL3_Optimizadas/TressorAnillosSL3PrincesaOroAmarillo.webp';

// SL5
import imgSl5BrillanteBlanco from '../assets/SL5_Optimizadas/TressorAnillosSL5BrillanteOroBlanco.webp';
import imgSl5BrillanteAmarillo from '../assets/SL5_Optimizadas/TressorAnillosSL5BrillanteOroAmarillo.webp';
import imgSl5CushionBlanco from '../assets/SL5_Optimizadas/TressorAnillosSL5CrushionOroBlanco.webp';
import imgSl5CushionAmarillo from '../assets/SL5_Optimizadas/TressorAnillosSL5CrushionOroAmarillo.webp';
import imgSl5OvaladoBlanco from '../assets/SL5_Optimizadas/TressorAnillosSL5OvalOroBlanco.webp';
import imgSl5OvaladoAmarillo from '../assets/SL5_Optimizadas/TressorAnillosSL5OvalOroAmarillo.webp';
import imgSl5PrincesaBlanco from '../assets/SL5_Optimizadas/TressorAnillosSL5PrincesaOroBlanco.webp';
import imgSl5PrincesaAmarillo from '../assets/SL5_Optimizadas/TressorAnillosSL5PrincesaOroAmarillo.webp';

//SL8
import imgSl8BrillanteBlanco from '../assets/SL8_Optimizadas/TressorAnillosSL8BrillanteOroBlanco.webp';
import imgSl8BrillanteAmarillo from '../assets/SL8_Optimizadas/TressorAnillosSL8BrillanteOroAmarillo.webp';
import imgSl8CushionBlanco from '../assets/SL8_Optimizadas/TressorAnillosSL8CrushionOroBlanco.webp';
import imgSl8CushionAmarillo from '../assets/SL8_Optimizadas/TressorAnillosSL8CrushionOroAmarillo.webp';
import imgSl8OvaladoBlanco from '../assets/SL8_Optimizadas/TressorAnillosSL8OvalOroBlanco.webp';
import imgSl8OvaladoAmarillo from '../assets/SL8_Optimizadas/TressorAnillosSL8OvalOroAmarillo.webp';
import imgSl8PrincesaBlanco from '../assets/SL8_Optimizadas/TressorAnillosSL8PrincesaOroBlanco.webp';
import imgSl8PrincesaAmarillo from '../assets/SL8_Optimizadas/TressorAnillosSL8PrincesaOroAmarillo.webp';

//SL10
import imgSl10BrillanteBlanco from '../assets/SL10_Optimizadas/TressorAnillosSL10BrillanteOroBlanco.webp';
import imgSl10BrillanteAmarillo from '../assets/SL10_Optimizadas/TressorAnillosSL10BrillanteOroAmarillo.webp';
import imgSl10CushionBlanco from '../assets/SL10_Optimizadas/TressorAnillosSL10CrushionOroBlanco.webp';
import imgSl10CushionAmarillo from '../assets/SL10_Optimizadas/TressorAnillosSL10CrushionOroAmarillo.webp';
import imgSl10OvaladoBlanco from '../assets/SL10_Optimizadas/TressorAnillosSL10OvalOroBlanco.webp';
import imgSl10OvaladoAmarillo from '../assets/SL10_Optimizadas/TressorAnillosSL10OvalOroAmarillo.webp';
import imgSl10PrincesaBlanco from '../assets/SL10_Optimizadas/TressorAnillosSL10PrincesaOroBlanco.webp';
import imgSl10PrincesaAmarillo from '../assets/SL10_Optimizadas/TressorAnillosSL10PrincesaOroAmarillo.webp';

//SL12
import imgSl12BrillanteBlanco from '../assets/Sl12-Optimizadas/TressorAnillosSL12BrillanteOroBlanco.webp';
import imgSl12BrillanteAmarillo from '../assets/Sl12-Optimizadas/TressorAnillosSL12BrillanteOroAmarillo.webp';
import imgSl12CushionBlanco from '../assets/Sl12-Optimizadas/TressorAnillosSL12CrushionOroBlanco.webp';
import imgSl12CushionAmarillo from '../assets/Sl12-Optimizadas/TressorAnillosSL12CrushionOroAmarillo.webp';
import imgSl12OvaladoBlanco from '../assets/Sl12-Optimizadas/TressorAnillosSL12OvalOroBlanco.webp';
import imgSl12OvaladoAmarillo from '../assets/Sl12-Optimizadas/TressorAnillosSL12OvalOroAmarillo.webp';
import imgSl12PrincesaBlanco from '../assets/Sl12-Optimizadas/TressorAnillosSL12PrincesaOroBlanco.webp';
import imgSl12PrincesaAmarillo from '../assets/Sl12-Optimizadas/TressorAnillosSL12PrincesaOroAmarillo.webp';

//SL15
import imgSl15BrillanteBlanco from '../assets/SL15-optimizadas/TressorAnillosSL15BrillanteOroBlanco.webp';
import imgSl15BrillanteAmarillo from '../assets/SL15-optimizadas/TressorAnillosSL15BrillanteOroAmarillo.webp';
import imgSl15CushionBlanco from '../assets/SL15-optimizadas/TressorAnillosSL15CrushionOroBlanco.webp';
import imgSl15CushionAmarillo from '../assets/SL15-optimizadas/TressorAnillosSL15CrushionOroAmarillo.webp';
import imgSl15OvaladoBlanco from '../assets/SL15-optimizadas/TressorAnillosSL15OvalOroBlanco.webp';
import imgSl15OvaladoAmarillo from '../assets/SL15-optimizadas/TressorAnillosSL15OvalOroAmarillo.webp';
import imgSl15PrincesaBlanco from '../assets/SL15-optimizadas/TressorAnillosSL15PrincesaOroBlanco.webp';
import imgSl15PrincesaAmarillo from '../assets/SL15-optimizadas/TressorAnillosSL15PrincesaOroAmarillo.webp';




// Mapeo de imágenes por configuración
const imageMap = {
    'SL-1': {
        'Brillante': {
            'Oro Blanco 18K': imgSl1BrillanteBlanco,
            'Oro Amarillo 18K': imgSl1BrillanteAmarillo,
            'Platino': imgSl1BrillanteBlanco
        },
        'Cushion': {
            'Oro Blanco 18K': imgSl1CushionBlanco,
            'Oro Amarillo 18K': imgSl1CushionAmarillo,
            'Platino': imgSl1CushionBlanco
        },
        'Ovalado': {
            'Oro Blanco 18K': imgSl1OvaladoBlanco,
            'Oro Amarillo 18K': imgSl1OvaladoAmarillo,
            'Platino': imgSl1OvaladoBlanco
        },
        'Princesa': {
            'Oro Blanco 18K': imgSl1PrincesaBlanco,
            'Oro Amarillo 18K': imgSl1PrincesaAmarillo,
            'Platino': imgSl1PrincesaBlanco
        }
    },
    'SL-2': {
        'Brillante': {
            'Oro Blanco 18K': imgSl2BrillanteBlanco,
            'Oro Amarillo 18K': imgSl2BrillanteAmarillo,
            'Platino': imgSl2BrillanteBlanco
        },
        'Cushion': {
            'Oro Blanco 18K': imgSl2CushionBlanco,
            'Oro Amarillo 18K': imgSl2CushionAmarillo,
            'Platino': imgSl2CushionBlanco
        },
        'Ovalado': {
            'Oro Blanco 18K': imgSl2OvaladoBlanco,
            'Oro Amarillo 18K': imgSl2OvaladoAmarillo,
            'Platino': imgSl2OvaladoBlanco
        },
        'Princesa': {
            'Oro Blanco 18K': imgSl2PrincesaBlanco,
            'Oro Amarillo 18K': imgSl2PrincesaAmarillo,
            'Platino': imgSl2PrincesaBlanco
        }
    },
    'SL-3': {
        'Brillante': {
            'Oro Blanco 18K': imgSl3BrillanteBlanco,
            'Oro Amarillo 18K': imgSl3BrillanteAmarillo,
            'Platino': imgSl3BrillanteBlanco
        },
        'Cushion': {
            'Oro Blanco 18K': imgSl3CushionBlanco,
            'Oro Amarillo 18K': imgSl3CushionAmarillo,
            'Platino': imgSl3CushionBlanco
        },
        'Ovalado': {
            'Oro Blanco 18K': imgSl3OvaladoBlanco,
            'Oro Amarillo 18K': imgSl3OvaladoAmarillo,
            'Platino': imgSl3OvaladoBlanco
        },
        'Princesa': {
            'Oro Blanco 18K': imgSl3PrincesaBlanco,
            'Oro Amarillo 18K': imgSl3PrincesaAmarillo,
            'Platino': imgSl3PrincesaBlanco
        }
    },
    'SL-5': {
        'Brillante': {
            'Oro Blanco 18K': imgSl5BrillanteBlanco,
            'Oro Amarillo 18K': imgSl5BrillanteAmarillo,
            'Platino': imgSl5BrillanteBlanco
        },
        'Cushion': {
            'Oro Blanco 18K': imgSl5CushionBlanco,
            'Oro Amarillo 18K': imgSl5CushionAmarillo,
            'Platino': imgSl5CushionBlanco
        },
        'Ovalado': {
            'Oro Blanco 18K': imgSl5OvaladoBlanco,
            'Oro Amarillo 18K': imgSl5OvaladoAmarillo,
            'Platino': imgSl5OvaladoBlanco
        },
        'Princesa': {
            'Oro Blanco 18K': imgSl5PrincesaBlanco,
            'Oro Amarillo 18K': imgSl5PrincesaAmarillo,
            'Platino': imgSl5PrincesaBlanco
        }
    },
    'SL-8': {
        'Brillante': {
            'Oro Blanco 18K': imgSl8BrillanteBlanco,
            'Oro Amarillo 18K': imgSl8BrillanteAmarillo,
            'Platino': imgSl8BrillanteBlanco
        },
        'Cushion': {
            'Oro Blanco 18K': imgSl8CushionBlanco,
            'Oro Amarillo 18K': imgSl8CushionAmarillo,
            'Platino': imgSl8CushionBlanco
        },
        'Ovalado': {
            'Oro Blanco 18K': imgSl8OvaladoBlanco,
            'Oro Amarillo 18K': imgSl8OvaladoAmarillo,
            'Platino': imgSl8OvaladoBlanco
        },
        'Princesa': {
            'Oro Blanco 18K': imgSl8PrincesaBlanco,
            'Oro Amarillo 18K': imgSl8PrincesaAmarillo,
            'Platino': imgSl8PrincesaBlanco
        }
    },
    'SL-10': {
        'Brillante': {
            'Oro Blanco 18K': imgSl10BrillanteBlanco,
            'Oro Amarillo 18K': imgSl10BrillanteAmarillo,
            'Platino': imgSl10BrillanteBlanco
        },
        'Cushion': {
            'Oro Blanco 18K': imgSl10CushionBlanco,
            'Oro Amarillo 18K': imgSl10CushionAmarillo,
            'Platino': imgSl10CushionBlanco
        },
        'Ovalado': {
            'Oro Blanco 18K': imgSl10OvaladoBlanco,
            'Oro Amarillo 18K': imgSl10OvaladoAmarillo,
            'Platino': imgSl10OvaladoBlanco
        },
        'Princesa': {
            'Oro Blanco 18K': imgSl10PrincesaBlanco,
            'Oro Amarillo 18K': imgSl10PrincesaAmarillo,
            'Platino': imgSl10PrincesaBlanco
        }
    },
    'SL-12': {
        'Brillante': {
            'Oro Blanco 18K': imgSl12BrillanteBlanco,
            'Oro Amarillo 18K': imgSl12BrillanteAmarillo,
            'Platino': imgSl12BrillanteBlanco
        },
        'Cushion': {
            'Oro Blanco 18K': imgSl12CushionBlanco,
            'Oro Amarillo 18K': imgSl12CushionAmarillo,
            'Platino': imgSl12CushionBlanco
        },
        'Ovalado': {
            'Oro Blanco 18K': imgSl12OvaladoBlanco,
            'Oro Amarillo 18K': imgSl12OvaladoAmarillo,
            'Platino': imgSl12OvaladoBlanco
        },
        'Princesa': {
            'Oro Blanco 18K': imgSl12PrincesaBlanco,
            'Oro Amarillo 18K': imgSl12PrincesaAmarillo,
            'Platino': imgSl12PrincesaBlanco
        }
    },
    'SL-15': {
        'Brillante': {
            'Oro Blanco 18K': imgSl15BrillanteBlanco,
            'Oro Amarillo 18K': imgSl15BrillanteAmarillo,
            'Platino': imgSl15BrillanteBlanco
        },
        'Cushion': {
            'Oro Blanco 18K': imgSl15CushionBlanco,
            'Oro Amarillo 18K': imgSl15CushionAmarillo,
            'Platino': imgSl15CushionBlanco
        },
        'Ovalado': {
            'Oro Blanco 18K': imgSl15OvaladoBlanco,
            'Oro Amarillo 18K': imgSl15OvaladoAmarillo,
            'Platino': imgSl15OvaladoBlanco
        },
        'Princesa': {
            'Oro Blanco 18K': imgSl15PrincesaBlanco,
            'Oro Amarillo 18K': imgSl15PrincesaAmarillo,
            'Platino': imgSl15PrincesaBlanco
        }
    }
};

/**
 * Obtiene la imagen correspondiente según las selecciones del formulario
 * @param {Object} formData - Datos del formulario
 * @param {string} formData.montura.text - Tipo de montura (ej: 'Tressor SL-1')
 * @param {string} formData.cutStyle.text - Tipo de corte (ej: 'Brillante', 'Cushion', etc.)
 * @param {string} formData.material.text - Material del anillo (ej: 'Oro Blanco 18K')
 * @returns {string} - Ruta de la imagen correspondiente
 */
export const getImageBySelections = (formData) => {
    const montura = formData.montura?.text;
    const corte = formData.cutStyle?.text;
    const material = formData.material?.text;

    // Extraer el modelo de la montura (ej: 'SL-1' de 'Tressor SL-1')
    const modelo = montura?.replace('Tressor ', '');

    // Verificar si tenemos la configuración completa
    if (modelo && corte && material && imageMap[modelo]?.[corte]?.[material]) {
        return imageMap[modelo][corte][material];
    }

    // Si no encontramos una coincidencia exacta, devolver imagen por defecto
    return imgAnilloBodasPrev;
};

// Componente React que utiliza la función
const ImageSelector = ({ formData, className, alt, style }) => {
    const imageSrc = getImageBySelections(formData);
    console.log(imageSrc);
    return (
        <img 
            src={imageSrc} 
            className={className} 
            alt={alt || "Preview anillo"} 
            style={style}
        />
    );
};

export default ImageSelector;